import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Box, CircularProgress } from "@mui/material";
import { AuthProvider, useAuth } from "./auth/AuthContext";
import Login from "./pages/Login";
import ReviewQueue from "./pages/ReviewQueue";
import Settings from "./pages/Settings";
import Layout from "./components/Layout";

function RequireAuth({ children, adminOnly }) {
  const { user, loading } = useAuth();
  if (loading) {
    return <Box sx={{ display: "grid", placeItems: "center", height: "100vh" }}><CircularProgress /></Box>;
  }
  if (!user) return <Navigate to="/login" replace />;
  if (adminOnly && !user.admin) return <Navigate to="/review" replace />;
  return children;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/review" element={<RequireAuth><Layout><ReviewQueue /></Layout></RequireAuth>} />
          <Route path="/settings" element={<RequireAuth adminOnly><Layout><Settings /></Layout></RequireAuth>} />
          <Route path="*" element={<Navigate to="/review" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
